import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enSiteHeaderTranslation from './locales/en/siteheader.json';
import enOrganizationFormTranslation from './locales/en/organizationform.json';
import enFrontPageTranslation from './locales/en/frontPage.json';
import enOrderFlowTranslation from './locales/en/orderFlow.json';
import enGlobalTranslation from './locales/en/global.json';
import enErrorCodesTranslation from './locales/en/errorCodes.json';
import enSideNavigationTranslation from './locales/en/sideNavigation.json';
import enUserGroupsTranslation from './locales/en/userGroups.json';
import enCustomerOrdersTranslation from './locales/en/customerOrders.json';
import enCustomerAssetsTranslation from './locales/en/customerAssets.json';
import enBackOfficeTranslation from './locales/en/backOffice.json';
import enInvoicingAccountTranslation from './locales/en/invoicingAccount.json';

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  returnObjects: true,
  resources: {
    en: {
      siteHeader: enSiteHeaderTranslation,
      organizationForm: enOrganizationFormTranslation,
      frontPage: enFrontPageTranslation,
      orderFlow: enOrderFlowTranslation,
      global: enGlobalTranslation,
      errorCodes: enErrorCodesTranslation,
      sideNavigation: enSideNavigationTranslation,
      userGroups: enUserGroupsTranslation,
      customerOrders: enCustomerOrdersTranslation,
      customerAssets: enCustomerAssetsTranslation,
      backOffice: enBackOfficeTranslation,
      invoicingAccount: enInvoicingAccountTranslation,
    },
  },
});
